import PromotionChallengeApproveSection from './PromotionChallengeApproveSection'
import { withPromotionChallengeApproveSection } from './withPromotionChallengeApproveSection'

const ConnectedPromotionChallengeApproveSection =
  withPromotionChallengeApproveSection(PromotionChallengeApproveSection)

export { ConnectedPromotionChallengeApproveSection as PromotionChallengeApproveSection }
